export default __webpack_public_path__ + "static/media/flow_layout_ico.62cb76b3.svg";